import { environment } from '../environments/environment';
import { AuthConfig } from 'angular-oauth2-oidc';

export var authConfig: AuthConfig = {

    // Url of the Identity Provider
    issuer: environment.KcgIssuer,

    // URL of the SPA to redirect the user to after login
    redirectUri: window.location.origin + '/' ,

    // loginUrl: window.location.origin + '/#login',
    // logoutUrl: window.location.origin + '/#login',

    // URL of the SPA to redirect the user after silent refresh
    silentRefreshRedirectUri: window.location.origin + '/assets/silent-refresh.html',
    //Timeout for silent refresh, default value is 20000ms

    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: environment.KcgClientID,

    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: environment.KcgScopes,
    // responseType: 'code',
    timeoutFactor: 0.65,

    clearHashAfterLogin: false,
    strictDiscoveryDocumentValidation: false

};
